import BaseMetricHandler from "./BaseMetricHandler";

const seriesColorMapping = {
  "Screen reject": "#FF7D7D",
  "Interview reject": "#ED4C4C",
  "On hold": "#CAD9E3",
  "Salary reject": "#C70202",
  Duplicate: "#B06E35",
  "Not responding": "#895629",
  "Candidate dropoff": "#971616",
  "Assignment reject": "#ed6a6a",
  "Offer declined": "#d21011",
};

export default class RejectionCountsHandler extends BaseMetricHandler {
  constructor(groupBy, filterBy) {
    super(groupBy, filterBy);
    this.graphType = "";
    this.dataType = "counts";
  }

  getGraphColor(label) {
    return seriesColorMapping[label];
  }

  getGraphOptions(backendData) {
    return this.groupBy === "source"
      ? this.getStackedChartOptions(backendData)
      : this.getPieChartOptions(backendData);
  }

  getPieChartOptions(backendData) {
    let series = backendData.data.map((value, index) => {
      return {
        name: backendData.labels[index],
        value: value,
      };
    });

    let options = {
      legend: {
        top: "bottom",
      },
      toolbox: {
        // show: true,
        // feature: {
        //   saveAsImage: { show: true },
        // },
      },
      tooltip: {
        trigger: "item",
      },
      label: {
        show: true,
        formatter: "{b}: {c}",
      },
      color: backendData.labels.map((label) => this.getGraphColor(label)),
      series: [
        {
          name: "Rejection counts",
          type: "pie",
          radius: [50, 100],
          center: ["50%", "50%"],
          roseType: "area",
          itemStyle: {
            borderRadius: 2,
          },
          data: series,
        },
      ],
    };

    return options;
  }

  getStackedChartOptions(backendData) {
    let series = backendData.data
      .map((series, index) => {
        return {
          name: backendData.labels[index],
          type: "bar",
          stack: true,
          data: series,
          color: this.getGraphColor(backendData.labels[index]),
        };
      })
      .slice(0, BaseMetricHandler.MaxLabels());

    let options = {
      notMerge: true,
      tooltip: {
        trigger: "axis",
      },
      legend: {
        top: "bottom",
      },
      // legend: {
      //   data: backendData.labels.slice(0, BaseMetricHandler.MaxLabels()),
      // },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "10%",
        containLabel: true,
      },
      // toolbox: {
      //   feature: {
      //     saveAsImage: {},
      //   },
      // },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: backendData.xAxis,
      },
      yAxis: {
        type: "value",
      },
      series: series,
    };
    return options;
  }

  getTableRepresentation(backendData) {
    if (this.groupBy === "source") {
      return super.getTableRepresentation(backendData);
    }
    let tableRows = [];
    if (backendData.length === 0) {
      return tableRows;
    }
    let labels = backendData.labels.slice(0, BaseMetricHandler.MaxLabels());

    tableRows.push(["Label", "Value"]);

    labels.forEach((label, index) => {
      let thisRow = [label, backendData.data[index]];
      tableRows.push(thisRow);
    });

    return tableRows;
  }
}
